import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Kolkata");

export default dayjs;
export function formatShortDate(date?: string | Date | null): string {
  if (!date) {
    return '';
  }
  return new Date(date).toLocaleDateString('en-In', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    timeZone: 'Asia/Kolkata'
  });
}
export const formatLongDate = (date?: string | Date | null): string => {
  if (!date) {
    return '';
  }
  return new Date(date).toLocaleDateString('en-in', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'Asia/Kolkata'
  });
};

export function formatShortDateAndTime(date?: string | Date | null): string {
  if (!date) {
    return '';
  }
  const d = new Date(date);
  let day = '' + d.getDate();
  const month = d.toLocaleString('en-US', {
    month: 'short',
  });
  const year = d.getFullYear().toString().substr(-2);
  if (day.length < 2) day = '0' + day;
  return (
    [day, month + "'" + year].join(' ') +
    ' ' +
    d.toLocaleString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
      timeZone: 'Asia/Kolkata'
    })
  );
}

export function formatDate_MMDDYYYY(date?: string | Date | null): string {
  if (!date) {
    return '';
  }
  // const d = new Date(date).toLocaleDateString('en-IN', {
  //   month: '2-digit',
  //   day: '2-digit',
  //   year: 'numeric',
  // });
  date = new Date(date);
  const d = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
  return d;
}
export function formatDate_DDMMYYYY(date?: string | Date | null): string {
  if (!date) {
    return '';
  }
  // const d = new Date(date).toLocaleDateString('en-IN', {
  //   month: '2-digit',
  //   day: '2-digit',
  //   year: 'numeric',
  // });
  date = new Date(date);
  const d = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
  return d;
}
export const getFormattedISTDateString = (date?: string | Date | null | Dayjs): string | null => {
  if (!date) {
    return null;
  }
  try {
    const indiaTime = dayjs.tz(date, "Asia/Kolkata").format('YYYY-MM-DD');
    return indiaTime;
  } catch (error) {
    console.error('Error in converting to India Timezone:', error);
    return null;
  }
}


export const getFormattedISTDate = (
  date?: string | Date | null | Dayjs
): string | null => {
  if (!date) return null;

  try {
    const formattedDate = dayjs(date)
      .format("YYYY-MM-DD");

    return formattedDate;
  } catch (error) {
    console.error("Error in converting to Date:", error);
    return null;
  }
};


export const getNthInvestmentWorkingDay = (
  days: number,
  startDate: string | Date | Dayjs,
  investmentDays: number[]
): Dayjs => {
  let date = dayjs(startDate);
  let count = 0;

  const hasCustomDays = investmentDays.length > 0;
  const investmentSet = new Set(investmentDays);

  let safety = 0;
  const MAX = 1000000;

  while (count < days && safety < MAX) {
    const dayOfWeek = date.day();
    const dayOfMonth = date.date();

    const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;

    const isValidInvestmentDay = hasCustomDays
      ? investmentSet.has(dayOfMonth)
      : !isWeekend;

    if (!isWeekend && isValidInvestmentDay) {
      count++;
      if (count === days) {
        return date.startOf("day"); 
      }
    }

    date = date.add(1, "day");
    safety++;
  }

  throw new Error("Could not compute date (safety limit reached)");
};